<!--#region Template -->

<ng-template #determinateTemplate>
    <div class="bg"
         [style.width.%]="this.value / this.maximum * 100"
         [style.height.px]="4">
    </div>
</ng-template>

<ng-template #indeterminateTemplate>
    <div class="bg indeterminate"
         [style.height.px]="4">
    </div>
</ng-template>

<!-- #endregion -->

<div class="progress-container">
    <div class="outer">
        <div class="inner">
            <ng-container *ngTemplateOutlet="this.isIndeterminate ? indeterminateTemplate : determinateTemplate"></ng-container>
        </div>
    </div>
</div>